module.exports = __webpack_public_path__ + "static/media/ab.6c5978f1.JPG";